import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import useRole from 'hooks/useRole';
import GridLayout from 'layouts/GridLayout';
import { editArtworkSchema } from 'pages/EditArtwork/validates/editArtworkSchema';

import EditArtworkActionBlock from '../EditArtworkActionBlock';
import EditArtworkDetailBlock from '../EditArtworkDetailBlock';

const EditArtworkMainContent = ({ artwork }) => {
  const role = useSelector((state) => state.auth.account.user.role);
  const { isArtist } = useRole();

  const artworkFormState = useForm({
    values: {
      editions: artwork?.editions,
      title: artwork?.title,
      selectedUser: artwork?.artist,
      artistName: isArtist ? artwork?.owner?.name : artwork?.artist_artwork?.artist_name,
      yearCreated: artwork?.year_created,
      periodYear: artwork?.period_created,
      checkedPeriod:
        artwork?.year_created || artwork?.period_created ? !artwork?.year_created : false,
      editionVolume: artwork?.total_edition,
      style: artwork?.style,
      medium: artwork?.medium,
      orientation: artwork?.orientation,
      height: artwork?.size?.height,
      width: artwork?.size?.width,
      depth: artwork?.size?.depth,
      description: artwork?.description,
      note: artwork?.note,
      images: artwork?.images,
      keyImages: artwork?.key_images,
      conditionImages: artwork?.condition_images || [],
      keyConditionImages: artwork?.key_condition_images || [],
      currency: artwork?.currency,
      isPublicCertificate: artwork?.is_public_certificate,
      isPublic: artwork?.is_public,
      price: artwork?.price ? parseFloat(artwork.price) : null,
      isHidePriceVisible: artwork?.is_hide_price,
      isAskPriceVisible: artwork?.is_ask_price_visible,
      contactInformation: artwork?.contact_information,
      hasCertificate: artwork?.has_certificate,
      checkedArtistUnknown: !artwork?.artist && !artwork?.artist_artwork,
      role,
      edition: artwork?.editions[0],
      artworkId: artwork?.id,
      inputSearchUser: '',
      contactInfoArtist: '',
      isShowCheckBoxCustom: !artwork?.artist && !artwork?.artist_artwork,
      isShowInputArtistName: !!artwork?.artist_artwork,
      isShowDialogArtistName: false,
      subjects: artwork?.subjects,
      yearOfBirthArtist: artwork?.artist_artwork?.year_of_birth,
      inventoryCode: artwork?.inventory_code,
      audioUrl: artwork?.audio_file || null,
      audioKey: null,
      audioRemoved: false,
      comments: artwork?.comments || [],
      show_collector_comment: artwork?.show_comments || false,
    },
    mode: 'onChange',
    resolver: yupResolver(editArtworkSchema),
  });

  return (
    <Box sx={{ pt: 3 }}>
      <GridLayout>
        <EditArtworkDetailBlock
          artworkFormState={artworkFormState}
          artwork={artwork}
          isArtist={isArtist}
        />
        <EditArtworkActionBlock artworkFormState={artworkFormState} />
      </GridLayout>
    </Box>
  );
};

export default EditArtworkMainContent;
